module.exports = __webpack_public_path__ + "static/media/135U1_LivingRoom.868d2196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U1_LivingRoom.jpg
// module id = 538
// module chunks = 0